import { render, staticRenderFns } from "./MainAdmin.vue?vue&type=template&id=420c5016"
import script from "./MainAdmin.vue?vue&type=script&lang=js"
export * from "./MainAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports